import request from 'store/common/utils';
export const syncProjectFinishesApi = (projectId, data) => request({
    url: `projects/${projectId}/finishes/sync`,
    method: 'POST',
    data,
});
